import { render } from "./toggler.vue?vue&type=template&id=2784441c&scoped=true&ts=true"
import script from "./toggler.vue?vue&type=script&lang=ts"
export * from "./toggler.vue?vue&type=script&lang=ts"

import "./toggler.vue?vue&type=style&index=0&id=2784441c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2784441c"]])

export default __exports__